module.exports = __webpack_public_path__ + "static/Audit trail 3-dc76fb443d7fb4279bd12530a8b345b1.png";